import React from 'react';
import { Button, Card, InputNumber, Input, Tooltip } from 'antd';
import { DeleteOutlined, HolderOutlined } from '@ant-design/icons';
import { useI18n } from 'hooks/useI18n';

const getItemWorkoutName = (item) =>
	item?.workoutName ||
	item?.name ||
	item?.title ||
	item?.exerciseName ||
	item?.label ||
	item?.data?.workoutName ||
	item?.data?.name ||
	item?.data?.title ||
	item?.data?.exerciseName ||
	item?.exercise?.name ||
	item?.exercise?.title ||
	item?.workout?.name ||
	item?.workout?.title;

const ExerciseItemCard = ({ item, index, onChange, onRemove, dragHandleProps = {} }) => {
	const { t } = useI18n();
	const workoutName = getItemWorkoutName(item) || t('workouts.template.exercise_item.unnamed_exercise');
	const handleChange = (field, value) => {
		onChange(index, { ...item, [field]: value });
	};

	return (
		<Card
			size="small"
			className="template-builder-exercise-item"
			bodyStyle={{ padding: '10px 12px' }}
		>
			<div className="template-builder-exercise-item__header">
				<div className="template-builder-exercise-item__title-group">
					<span {...dragHandleProps} className="template-builder-exercise-item__drag-handle">
						<HolderOutlined />
					</span>
					<div className="template-builder-exercise-item__name" title={workoutName} aria-label={workoutName}>
						<span className="template-builder-exercise-item__name-text">{workoutName}</span>
					</div>
				</div>
				<Button
					className="template-builder-exercise-item__remove-btn"
					size="small"
					danger
					icon={<DeleteOutlined />}
					onClick={() => onRemove(index)}
				/>
			</div>

			<div className="template-builder-exercise-item__meta">
				<div className="template-builder-exercise-item__field template-builder-exercise-item__field--sets">
					<label className="template-builder-exercise-item__label">{t('workouts.template.exercise_item.sets')}</label>
					<Tooltip title={t('workouts.template.exercise_item.sets')}>
						<InputNumber
							className="template-builder-exercise-item__control template-builder-exercise-item__control--sm"
							size="small"
							min={1}
							max={20}
							value={item.sets}
							onChange={(val) => handleChange('sets', val)}
							placeholder={t('workouts.template.exercise_item.sets')}
						/>
					</Tooltip>
				</div>

				<div className="template-builder-exercise-item__field template-builder-exercise-item__field--reps">
					<label className="template-builder-exercise-item__label">{t('workouts.template.exercise_item.reps')}</label>
					<Tooltip title={t('workouts.template.exercise_item.reps')}>
						<Input
							className="template-builder-exercise-item__control template-builder-exercise-item__control--sm"
							size="small"
							value={item.reps}
							onChange={(e) => handleChange('reps', e.target.value)}
							placeholder={t('workouts.template.exercise_item.reps')}
						/>
					</Tooltip>
				</div>

				<div className="template-builder-exercise-item__field template-builder-exercise-item__field--rest">
					<label className="template-builder-exercise-item__label">{t('workouts.template.exercise_item.rest_seconds')}</label>
					<Tooltip title={t('workouts.template.exercise_item.rest_seconds')}>
						<InputNumber
							className="template-builder-exercise-item__control template-builder-exercise-item__control--sm"
							size="small"
							min={0}
							step={15}
							value={item.restSeconds}
							onChange={(val) => handleChange('restSeconds', val)}
							placeholder={t('workouts.template.exercise_item.rest')}
						/>
					</Tooltip>
				</div>

				<div className="template-builder-exercise-item__field template-builder-exercise-item__field--notes">
					<label className="template-builder-exercise-item__label">{t('workouts.template.exercise_item.notes')}</label>
					<Tooltip title={t('workouts.template.exercise_item.notes')}>
						<Input
							className="template-builder-exercise-item__control"
							size="small"
							value={item.notes}
							onChange={(e) => handleChange('notes', e.target.value)}
							placeholder={t('workouts.template.exercise_item.notes')}
						/>
					</Tooltip>
				</div>
			</div>
		</Card>
	);
};

export default ExerciseItemCard;
